import { input } from './icons-input-prompts';

export const Kenney = {
  input,
};
